import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'categories-view_c2_to_c3_navigation_c2_category_carousel-view';
/**
 * It&#39;s tracking when the c2-category carousel been viewed
 */
export function trackCategoriesViewC2ToC3NavigationC2CategoryCarouselView(customParameterToken, customParameterToken2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken, customParameterToken2 },
    });
}
